import React, { useEffect, useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink, Badge } from "reactstrap";
import {
  getEpisodeByEmission,
  getDraftForEpisode,
} from "@store/action/planning/EpisodeAction";
import { getPodacstForEmission } from "@store/action/planning/EmissionAction";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { Download, Play } from "react-feather";
import { store } from "@store/StoreConfig";
import { addMusic } from "@src/redux/action/player/PlayerFrontOfficeAction";
import { UncontrolledTooltip } from "reactstrap";
import {
  BsCalendarDate,
  BsFillTagsFill,
  BsMusicNoteList,
} from "react-icons/bs";
import { BiTimeFive, BiCategoryAlt } from "react-icons/bi";
import { FaUserTie } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { CustomPagination } from "@store/action/GlobalAction";
let data = {
  currentsong: null,
  is_web_rtc: false,
  download: null,
};
const API = process.env.REACT_APP_MICRO_PLANING_URL;

const TabsCentered = ({ t }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [active, setActive] = useState("1");
  const [status, setStatus] = useState(1);
  const episodes = useSelector((state) => state.episodes);
  const episode = episodes && episodes?.episodesByEmission;
  const emissions = useSelector((state) => state.emissions);
  const podcastList = emissions && emissions.podcastList;
  const podcastListLength =
    podcastList && podcastList.length
      ? podcastList && podcastList[0].length
      : 0;
  const EpisodeListLength =
    episode && episode.length ? episode && episode[0].length : 0;
  const id = useParams().id;
  const dispatch = useDispatch();
  const getAvenir = () => {
    dispatch(getEpisodeByEmission(status, id));
  };
  const toggle = (tab) => {
    if (active !== tab) {
      setActive(tab);
    }
  };
  const dateFormat = (date) => {
    const dateToFormat = new Date(date);
    return `${dateToFormat.getFullYear()}-${
      dateToFormat.getMonth() + 1
    }-${dateToFormat.getDay()}`;
  };
  const timeFormat = (date) => {
    const dateToFormat = new Date(date);
    return `${dateToFormat.getHours()}:${
      dateToFormat.getMinutes() + 1
    }:${dateToFormat.getSeconds()}`;
  };
  const PlayerFrontOfficeReducer = useSelector(
    (state) => state.PlayerFrontOfficeReducer
  );
  const renderPodcastList = () => {
    return (
      podcastList &&
      podcastList[0]?.map((item, i) => (
        <div className="col-md-4 col-lg-4 mt-0" key={i}>
          <div className="contact-info-ui">
            <div className="cursor-pointer mt-0 mb-1">
              <Link
                to={`/podcast/${item.pod_id}`}
                style={{ marginRight: "5px" }}
              >
                <FaEye
                  style={{ display: "inline !important" }}
                  size={20}
                  id="Show"
                />
              </Link>
              {PlayerFrontOfficeReducer?.currentSong === item.file_path ? (
                <a>
                  <BsMusicNoteList size={20} />
                </a>
              ) : (
                <Play
                  className="pointer_cursor "
                  id="Play"
                  style={{ display: "inline !important" }}
                  size={20}
                  onClick={() =>
                    store.dispatch(
                      addMusic(
                        (data = {
                          currentsong: item.file_path,
                          download: `${API}/podcast/download/${item.pod_id}`,
                          item_data: item,
                          is_web_rtc: false,
                          has_video: item.name.endsWith("mp4") && true,
                        })
                      )
                    )
                  }
                />
              )}

              <UncontrolledTooltip placement="bottom" target="Play">
                {t("Play")}
              </UncontrolledTooltip>
              <a
                href={`${API}/podcast/download/${item.pod_id}`}
                style={{ textDecoration: "black" }}
                download
              >
                <Download
                  size={20}
                  className="pointer_cursor mr-100"
                  id="Download"
                />
              </a>
              <UncontrolledTooltip placement="bottom" target="Download">
                {t("Download")}
              </UncontrolledTooltip>
            </div>
            <div style={{ textAlign: "center" }}>
              <div className="mail-body">
                <div className="mail-message">
                  <h3 className="text-truncate mb-0">{item.name}</h3>
                </div>
              </div>
              <div className="mail-body">
                <div className="mail-message">
                  <h5 className="text-truncate mb-0">{item.description}</h5>
                </div>
              </div>
              <div className="mail-body">
                <div className="mail-message">
                  <p className="text-truncate mb-0">{item.created_at}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))
    );
  };
  const renderEmissionList = () => {
    return (
      episode &&
      episode[0]?.map((item, i) => (
        <div
          className="col-md-8 col-lg-4 mt-0"
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: "10px",
          }}
          key={i}
        >
          <div
            className="contact-info"
            style={{ height: "100%", width: "100%" }}
          >
            <div style={{ margin: "50px 0 " }}>
              <div style={{ textAlign: "center" }}>
                <div className="mail-body">
                  <img
                    style={{ height: "35%", objectFit: "cover", width: "100%" }}
                    src={item.emission.picture}
                  />
                  <div className="mail-message">
                    <h3 className="text-truncate mb-0">{item.name}</h3>
                  </div>
                </div>

                <div
                  style={{
                    width: "100%",
                    height: "",
                    flexDirection: "column",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    backgroundColor: "#f8f8f8",
                    marginTop: "15px",
                  }}
                >
                  <div className="mail-body">
                    <div
                      className="mail-message"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        borderRadius: "3px",
                      }}
                    >
                      <BsCalendarDate style={{ marginRight: "5px" }} />{" "}
                      <p className="text-truncate mb-0">
                        {item?.episode_schedule.length &&
                          dateFormat(item?.episode_schedule[0].start_datetime)}
                      </p>
                    </div>
                    <div
                      className="mail-message"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <BiTimeFive style={{ marginRight: "5px" }} />{" "}
                      <p className="text-truncate mb-0">
                        {item?.episode_schedule.length &&
                          timeFormat(item?.episode_schedule[0].start_datetime)}
                      </p>
                    </div>
                  </div>

                  <div className="mail-body">
                    <div className="mail-message">
                      <FaUserTie /> {t("guests")} :{" "}
                      {item?.guest?.map((ele, i) => (
                        <Badge
                          style={{ margin: "2px", fontSize: "10px" }}
                          key={"ushnokeyGest" + i}
                          color="light-primary"
                        >
                          {ele.first_name + " " + ele.last_name}
                        </Badge>
                      ))}
                    </div>
                  </div>
                  <div className="mail-body">
                    <div className="mail-message">
                      <FaUserTie /> {t("Classification")} :{" "}
                      <Link
                        to={`/episode/classification/${item.classification?.id}`}
                      >
                        {item.classification?.name}
                      </Link>
                    </div>
                  </div>

                  <div className="mail-body">
                    <div className="mail-message">
                      <BsFillTagsFill /> {t("tags")} :{" "}
                      {item?.tags?.map((ele, i) => (
                        <Link
                          key={"ushnokeyEpisode" + i}
                          to={`/episode/tag/${ele.slug}`}
                        >
                          <Badge
                            style={{ margin: "2px", fontSize: "10px" }}
                            color="light-secondary"
                          >
                            #{ele.name}
                          </Badge>
                        </Link>
                      ))}
                    </div>
                  </div>

                  <div className="mail-body">
                    <div className="mail-message">
                      <BiCategoryAlt /> {t("categorys")} :{" "}
                      {item?.categories?.map((ele, i) => (
                        <Link
                          key={"ushnokeyCatefgory" + i}
                          to={`/episode/category/${ele.slug}`}
                        >
                          <Badge
                            style={{ margin: "2px", fontSize: "10px" }}
                            color="light-warning"
                          >
                            {ele.name}
                          </Badge>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))
    );
  };
  const renderDraftList = () => {
    return (
      episodes.draft_episode &&
      episodes.draft_episode?.data?.map((item, i) => (
        <div className="col-md-8 col-lg-4 mt-0" key={i}>
          <div className="mb-1" style={{ backgroundColor: "#fff" }}>
            <div style={{ textAlign: "center" }}>
              <div className="mail-body">
                <div className="mail-message">
                  <h3 className="text-truncate mb-0">{item.name}</h3>
                </div>
              </div>

              <div className="p-2">
                <div className="mail-body">
                  <div className="mail-message">
                    <FaUserTie /> {t("guests")} :{" "}
                    {item?.guest?.map((ele, i) => (
                      <Badge
                        style={{ margin: "2px", fontSize: "10px" }}
                        key={"ushnokeyGest" + i}
                        color="light-primary"
                      >
                        {ele.first_name + " " + ele.last_name}
                      </Badge>
                    ))}
                  </div>
                </div>
                <div className="mail-body">
                  <div className="mail-message">
                    <FaUserTie /> {t("Classification")} :{" "}
                    <Link
                      to={`/episode/classification/${item.classification?.id}`}
                    >
                      {item.classification?.name}
                    </Link>
                  </div>
                </div>

                <div className="mail-body">
                  <div className="mail-message">
                    <BsFillTagsFill /> {t("tags")} :{" "}
                    {item?.tags?.map((ele, i) => (
                      <Link to={`/episode/tag/${ele.slug}`}>
                        <Badge
                          style={{ margin: "2px", fontSize: "10px" }}
                          key={"ushnokeyEpisode" + i}
                          color="light-secondary"
                        >
                          #{ele.name}
                        </Badge>
                      </Link>
                    ))}
                  </div>
                </div>

                <div className="mail-body">
                  <div className="mail-message">
                    <BiCategoryAlt /> {t("categorys")} :{" "}
                    {item?.categories?.map((ele, i) => (
                      <Link
                        key={"ushnokeyCatefgory" + i}
                        to={`/episode/category/${ele.slug}`}
                      >
                        <Badge
                          style={{ margin: "2px", fontSize: "10px" }}
                          color="light-warning"
                        >
                          {ele.name}
                        </Badge>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))
    );
  };
  useEffect(() => {
    dispatch(getPodacstForEmission(id));
    dispatch(getEpisodeByEmission(status, id));
    dispatch(
      getDraftForEpisode(id, {
        page: currentPage,
      })
    );
  }, [dispatch, id, currentPage]);
  const handlePageChange = (x) => {
    setCurrentPage(x.selected + 1);
  };
  const count = episodes.draft_episode.total;

  return (
    <div className="podcast-nav-bav">
      <Nav className="justify-content-center" tabs>
        <NavItem>
          <NavLink
            active={active === "1"}
            onClick={() => {
              toggle("1");
            }}
          >
            {t("Podcast")}( {podcastListLength} )
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            active={active === "2"}
            onClick={() => {
              toggle("2");
              getAvenir();
            }}
          >
            {t("Coming")}({EpisodeListLength})
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            active={active === "3"}
            onClick={() => {
              toggle("3");
            }}
          >
            {t("Draft")}({episodes.draft_episode.total})
          </NavLink>
        </NavItem>
      </Nav>

      <TabContent className="py-50" activeTab={active}>
        <TabPane tabId="1">
          <div className="row">{renderPodcastList()} </div>
        </TabPane>
        <TabPane tabId="2">
          <div className="row"> {renderEmissionList()} </div>
        </TabPane>
        <TabPane tabId="3">
          <div className="row"> {renderDraftList()} </div>
          <div className="d-flex justify-content-center">
            {CustomPagination(count, 5, handlePageChange)}
          </div>
        </TabPane>
      </TabContent>
    </div>
  );
};
export default TabsCentered;
